/**
 * Created by mykurisu on 2017/9/26.
 */
import React from 'react'
import axios from 'axios'
import ChimeePlayer from 'chimee-player';
import {TimeStream} from '../../utils'
import '../../styles/chimee/ChimeeVideo.css';
import '../../styles/chimee/ChimeeMenu.css';
import '../../styles/chimee/ChimeeCenterState.css';
import playIconBigImg from '../../images/recorded/play_icon_big.png'
import tipsIconImg from '../../images/tips-icon.png'


class VideoArea extends React.Component {

    constructor() {
        super();
        this.state = {
            videoInfo: null,
            init: false,
            videoList: {},
            canPlayVideo: false
        }
    }

    componentDidMount() {
        if(!this.props.video_info || this.props.video_info.qcloud_video_file_id === 0)
            return
        axios.get(`/api/bridge/qcvideo/${this.props.video_info.qcloud_video_file_id}`)
            .then(res => {
                if (res.data.data.retcode === 0){
                    let info = res.data.data
                    if (this.state.videoList[this.props.lecture.id]) {
                        info.play_url = this.state.videoList[this.props.lecture.id]
                    }
                    this.setState({
                        videoInfo: info,
                        init: true
                    })

                    // 安卓和pc端加载新的视频播放器
                    let elem = document.getElementById('chimee-container')
                    if (window.systemType !== 'ios' && window.systemType !== 'android' && elem) {
                        let chimeeOptions = {
                            wrapper: '#chimee-container',
                            src: info.play_url.replace('http://', 'https://'),
                            isLive: false,
                            box: 'native',
                            poster: this.props.poster,
                            autoplay: false,
                            controls: true,
                            xWebkitAirplay: true
                        }
                        let player = new ChimeePlayer(chimeeOptions)
                        player.on('play', () => {this.props.handlePlay && this.props.handlePlay()})
                        player.on('pause', () => {this.props.handlePause && this.props.handlePause()})
                    }
                }
            })
    }

    isNoresourceAndNostart () {
        return (!this.state.videoInfo || (this.state.videoInfo && this.state.videoInfo.data.file_info.status !== '2')) && this.props.lecture.start_timestamp > Date.now() / 1000
    }

    isNoresourceAndStarting () {
        return (!this.state.videoInfo || (this.state.videoInfo && this.state.videoInfo.data.file_info.status !== '2')) && this.props.lecture.start_timestamp <= Date.now() / 1000
    }

    renderPlayAreaControl() {
        return (
            <div className="video__mask-control"
                  style={{backgroundImage: `url(${this.props.poster || ''})`}}
                 onClick={() => this.setState({canPlayVideo: true})}>
                <div className="control__btn">
                    <img
                        src="https://static-cos.lycheer.net/picture/6163375_b0d77ca953965755b4c8b399761abbea.jpg"
                        alt=""/>
                    {Math.round(this.state.videoInfo.video_size / 1024 / 1024)}M流量
                </div>
            </div>
        )
    }

    renderPlayArea() {
        if (this.props.canIListen){
            if (this.state.init){
                if (this.state.videoInfo){
                    if (this.state.videoInfo && this.state.videoInfo.data.file_info.status === '2'){
                        if (window.systemType !== 'ios' && window.systemType !== 'android') {
                            return (
                                <div id="chimee-container" className="chimee-container" style={{height: '100%', width: '100%'}}>
                                    <video tabIndex="-1" id="top_video" />
                                </div>
                            )
                        } else {
                            if (!this.state.canPlayVideo) {
                                return this.renderPlayAreaControl()
                            }
                            return (
                                <video is
                                       ref="videoPlayer"
                                       id="video-player"
                                       controlsList="nodownload"
                                       playsinline="true"
                                       webkit-playsinline=""
                                       x-webkit-airplay="true"
                                       autoPlay={true}
                                       poster={this.props.poster}
                                       src={window.systemType !== 'ios' ? this.state.videoInfo.play_url.replace('http://', 'https://') : this.state.videoInfo.play_url}
                                       controls="controls"
                                       onPlay={() => this.props.handlePlay && this.props.handlePlay()}
                                       onPause={() => this.props.handlePause && this.props.handlePause()}
                                />
                            )
                        }
                    } else {
                        // 视频没上传或在转码中
                        return this.renderNoResource()
                    }
                }else {
                    return (
                        <div className="video-mask" style={{backgroundImage: `url(${this.props.poster})`}}>
                            <div className="video-mask-bg" onClick={() => this.props.handleShowEnter()}>
                                {
                                    this.props.lecture.lecture_type === 'password_lecture' && (
                                        <div className="video-mask-btn-icon">
                                            <img src={playIconBigImg} alt=""/>
                                            <span>密码验证即可收听</span>
                                        </div>
                                    )
                                }
                                {
                                    this.props.lecture.lecture_type !== 'password_lecture' && (
                                        <div className="video-mask-play-icon">
                                            <img src={playIconBigImg} alt=""/>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                }
            } else {
                if (!this.props.video_info) {
                    return this.renderNoResource()
                }
            }
        }else {
            // 没有购买
            return (
                <div className="video-mask" style={{backgroundImage: `url(${this.props.poster})`}}>
                    <div className="video-mask-bg" onClick={() => this.props.handleShowEnter()}>
                        {
                            this.props.lecture.lecture_type === 'password_lecture' && (
                                <div className="video-mask-btn-icon">
                                    <img src={playIconBigImg} alt=""/>
                                    <span>密码验证即可收听</span>
                                </div>
                            )
                        }
                        {
                            this.props.lecture.lecture_type !== 'password_lecture' && (
                                <div className="video-mask-play-icon">
                                    <img src={playIconBigImg} alt=""/>
                                </div>
                            )
                        }
                    </div>
                </div>
            )
        }
    }

    // 没转码或上传时
    renderNoResource () {
        // 学员端
        if (!this.props.role.is_manager) {
            // 还没开始
            if (this.props.lecture.start_timestamp > Date.now() / 1000) {
                return (
                    <div className="no-resource-no-ready" style={{fontSize: '16px'}}>
                        <p><img src={tipsIconImg} style={{width: "100px"}} alt="tips_icon"/></p>
                        <p style={{opacity: 0}}>开课时间: {TimeStream(this.props.lecture.start_timestamp, 'MD_HM')}</p>
                        <p>敬请期待</p>
                    </div>
                )
            } else {
                return (
                    <div className="video-mask" style={{backgroundImage: `url(${this.props.poster})`}}>
                        <div className="video-mask-bg">
                            <div className="video-mask-btn">
                                当前课程尚未上传视频
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            // 讲师端
            return (
                <div className="video-mask" style={{backgroundImage: `url(${this.props.poster})`}}>
                    <div className="video-mask-bg">
                        <div className="video-mask-btn">
                            {!this.state.videoInfo ? '浏览器打开讲师管理后台上传视频' : '视频处理中...'}
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div className={`video-area ${(this.props.canIListen && this.isNoresourceAndNostart()) ? 'black' : '' }`}>
                {this.renderPlayArea()}
            </div>
        )
    }
}

export default VideoArea



// WEBPACK FOOTER //
// ./src/pages/recordedPage/VideoArea.js